export const RETOOL_ITEM_DEFAULT_VALUE_ID = 15;
export const RETOOL_BRAND_DEFAULT_VALUE_ID = 14;
export const RETOOL_COMPANY_DEFAULT_VALUE_ID = 21;
export const CUSTOM_REPLIT_DEFAULT_APP_ID = 22;
export const CUSTOM_APPS_BRANDS_VISIBILITY_ID = 23;

export const VCDB_DEFAULT_VALUE_ID = 16;
export const POWER_BI_REPORT_VALUE_ID = 17;

export const STRING_DEFAULT_VALUE_IDS = [
  RETOOL_BRAND_DEFAULT_VALUE_ID,
  RETOOL_ITEM_DEFAULT_VALUE_ID,
  POWER_BI_REPORT_VALUE_ID,
  RETOOL_COMPANY_DEFAULT_VALUE_ID,
];
export const MULTI_SELECT_DEFAULT_VALUE_IDS = [18, 19];
